import { render, staticRenderFns } from "./HojasSeguridadPagination.vue?vue&type=template&id=39ab31ea&"
import script from "./HojasSeguridadPagination.vue?vue&type=script&lang=js&"
export * from "./HojasSeguridadPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports